<section class="d-flex flex-column gap-3 animated fadeIn">
    <div class="col-12 bg-light py-3">
        @for (bundleProduct of (bundle()?.items); track $index) {
        @if (!bundleProduct.isRemoved) {
        <div class="row d-flex justify-content-between p-3 py-1 animated fadeIn">
            <div class="col-4">
                <h6 class="card-title">{{ bundleProduct.name }} {{bundleProduct.packageName ? (' | ' +
                    bundleProduct.packageName) : (bundleProduct.display ? (' | ' + bundleProduct.display) : '')}}
                </h6>
                @if (bundleProduct.presentation) {
                <small class="card-text">
                    {{ bundleProduct.presentation.quantity }}
                    {{ bundleProduct.presentation.type }}
                </small>
                }
            </div>
            @if (!bundle().isLocked) {
            <div class="col-4 d-flex justify-content-center align-content-center flex-wrap">
                <mat-form-field class="rounded-selector d-flex" subscriptSizing="dynamic">
                    @if (bundleProduct?.quantity >= 10) {
                    <input type="text" matInput [value]="bundleProduct.quantity"
                        (input)="onChangeInputBundleItem(bundleProduct, $event)">
                    } @else {
                    <mat-select [value]="bundleProduct.quantity"
                        (selectionChange)="onChangeQuantityBundleItem(bundleProduct, $event)">
                        @for (number of [1, 2, 3, 4, 5, 6, 7, 8, 9]; track $index) {
                        <mat-option [value]="number">{{ number }}</mat-option>
                        }
                        <mat-option value="10">10+</mat-option>
                    </mat-select>
                    }
                </mat-form-field>
            </div>
            <div class="col-4 d-flex justify-content-end align-content-center flex-wrap">
                <div class="row">
                    <div class="col-6 text-nowrap">
                        <h4 class="fw-bold m-0 p-0">{{ bundleProduct.price | currency }}</h4>
                    </div>
                    <div class="col-6 d-flex justify-content-end  align-content-center flex-wrap">
                        <i (click)="removeProductFromBundle(bundleProduct)" class="fa fa-trash" aria-hidden="true"></i>
                    </div>
                </div>
            </div>
            }

        </div>
        }
        }
        @if (removedBundleItems().size) {
        @for (bundleProduct of removedBundleItems().values(); let bundleProductIdx = $index; track bundleProductIdx) {
        <div class="row d-flex justify-content-between p-3 py-1 opacity-50 animated fadeIn">
            <div class="col-6">
                <h6 class="card-title">{{ bundleProduct.name }} {{bundleProduct.packageName ? (' | ' +
                    bundleProduct.packageName) : (bundleProduct.display ? (' | ' + bundleProduct.display) : '')}}
                </h6>
                @if (bundleProduct?.presentation) {
                <small class="card-text">
                    {{ bundleProduct.presentation.quantity }}
                    {{ bundleProduct.presentation.type }}
                </small>
                }
            </div>
            <div class="col-6 d-flex justify-content-end align-content-center flex-wrap">
                <div class="row">
                    <div class="col-12 d-flex justify-content-end align-content-center flex-wrap">
                        <span (click)="restoreBundleProduct(bundleProduct)"
                            class=" btn text-nowrap text-decoration-underline">Restore product</span>
                    </div>
                </div>
            </div>
        </div>
        }
        }
    </div>

    <div class="col-12 d-flex justify-content-center align-content-center flex-wrap">
        @if (bundle().isLocked) {
        <button class="btn btn-sm btn-outline-secondary mx-2" data-bs-toggle="collapse"
            [attr.data-bs-target]="'#'+toggleId()" aria-expanded="false" [attr.aria-controls]="toggleId()">
            Close
        </button>
        } @else {
        <button [disabled]="!bundleHasPendingChanges()" class="btn btn-sm btn-outline-secondary mx-2"
            (click)="discardBundleEdits()">
            Discard changes
        </button>
        <button [disabled]="!bundleHasPendingChanges()" class="btn btn-sm btn-primary" (click)="saveBundleChanges()">
            Update bundle
        </button>
        }
    </div>
</section>